import { Skeleton, flex, ph } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { useMemo } from 'react';
import { View } from 'react-native';
import { DataTable } from 'react-native-paper';

import { MessageRow } from './message-row';
import { MessageItem } from '../../interfaces/message-notification';

interface MessageTableProps {
  messages?: MessageItem[];
  isLoading: boolean;
  onRemove: (id: string) => void;
  onPagination: (page: number, itensPerPage: number) => void;
  pagination: { page: number; itemsPerPage: number };
}
export const MessageTable = ({
  onPagination,
  messages,
  isLoading,
  onRemove,
  pagination = {
    page: 1,
    itemsPerPage: 10,
  },
}: MessageTableProps) => {
  const { page, itemsPerPage } = pagination;

  const { from, to, numberOfPages } = useMemo(() => {
    const totalItems = messages?.length || 0;

    return {
      from: (page - 1) * itemsPerPage + 1,
      to: Math.min(page * itemsPerPage, totalItems),
      numberOfPages: Math.ceil(totalItems / itemsPerPage),
    };
  }, [itemsPerPage, messages?.length, page]);

  const onPageChange = (page: number) => {
    onPagination(page, itemsPerPage);
  };

  const onItemsPerPageChange = (itemsPerPage: number) => {
    onPagination(1, itemsPerPage);
  };

  return (
    <DataTable>
      {isLoading ? (
        <>
          {[1, 2].map((key) => (
            <DataTable.Row key={key}>
              <DataTable.Cell>
                <Skeleton />
              </DataTable.Cell>
            </DataTable.Row>
          ))}
        </>
      ) : (
        <>
          <DataTable.Header style={[ph(0)]}>
            <Title flex={0.8}>Date & Time</Title>
            <Title flex={0.5}>From</Title>
            <Title flex={1}>Message</Title>
            <View style={flex('flex-0.4')} />
          </DataTable.Header>
          {messages?.map((item: any) => (
            <MessageRow
              key={item.id}
              item={item}
              onRemove={() => onRemove(item.id)}
            />
          ))}
          <DataTable.Pagination
            page={page}
            numberOfPages={numberOfPages}
            onPageChange={onPageChange}
            label={`${from}-${to} of ${messages?.length}`}
            numberOfItemsPerPageList={[5, 10, 25, 50, 100]}
            numberOfItemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            showFastPaginationControls
            selectPageDropdownLabel="Rows per page"
          />
        </>
      )}
    </DataTable>
  );
};

type FlexProps = {
  flex: number;
};

const Title = styled(DataTable.Title)<FlexProps>`
  padding-horizontal: 4px;
  flex: ${({ flex }) => flex};
  cursor: pointer;
`;
